import { Action, ThunkAction, configureStore } from '@reduxjs/toolkit';

import mapsReducer from './maps.reducer';
import devicesReducer from './devices.reducer';
import userReducer from './user.reducer';
import organizationsReducer from './organizations.reducer';

export const store = configureStore({
    reducer: {
        maps: mapsReducer,
        devices: devicesReducer,
        user: userReducer,
        organizations: organizationsReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
